import React, { useState, useEffect, useCallback } from "react";
import "./../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import DatePicker from "../../components/DatePicker";

const InventoryMovementReport = () => {
    // ตัวแปรเก็บชื่อหน้าจอ
    const [name, setName] = useState(null);

    // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
    const [searchCriteria, setSearchCriteria] = useState([]);

    // ข้อมูลที่แสดงรายงาน
    const [filteredData, setFilteredData] = useState([]);

    // สำหรับ Table รายงาน
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const [exportController, setExportController] = useState({
        exportToExcel: null,
        isExporting: false,
        hasData: false,
    });

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
        setName("2.1 รายงาน Inventory Movement (แยกตามแผนก/คลัง)");
        setSearchCriteria(
            {
                stcDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
                whCode: null,
                whName: null
            }
        );
        setFilteredData([]);
    };

    const handleChangeCriteria = (e) => {
        const { name, value } = e.target;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChangeDate = (value, name) => {
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: value ? value.format('YYYY-MM-DD') : null,
        }));
    };

    const handleSearch = async () => {
        try {
            setFilteredData([]);

            let query = '';

            if (searchCriteria.stcDate) {
                query += `AND CONVERT(DATE, STC_Date) = '${searchCriteria.stcDate}' `;
            }

            if (searchCriteria.whCode) {
                query += `AND WH_Code = '${searchCriteria.whCode}' `;
            }
            if (searchCriteria.whName) {
                query += `AND WH_Name = '${searchCriteria.whName}' `;
            }

            const response = await getDataWithComp('API_1201_WH_ITEM_STC', query.trim());

            if (response && response.length > 0) {
                setFilteredData(response);
            }
        } catch (error) {
            getAlert("FAILED", error.response?.message || error.message);
        }
    };

    const handleExportReady = useCallback((state) => {
        setExportController((prev) => {
            if (
                prev.exportToExcel === state.exportToExcel &&
                prev.isExporting === state.isExporting &&
                prev.hasData === state.hasData
            ) {
                return prev;
            }
            return state;
        });
    }, []);

    const handleExportClick = useCallback(() => {
        if (exportController?.exportToExcel) {
            exportController.exportToExcel();
        } else {
            getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
        }
    }, [exportController]);

    return (
        <>
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <Breadcrumbs
                                page={name}
                                items={[
                                    { name: "รายงาน", url: "/reports" },
                                    { name: name, url: "/inventory-movement-report" },
                                ]}
                            />
                        </div>
                        <div className="row">
                            {/* Criteria */}
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4>เงื่อนไขการค้นหา</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="whCode" className="form-label">รหัสคลัง</label>
                                                <DatePicker
                                                    label=""
                                                    name="stcDate"
                                                    value={searchCriteria.stcDate}
                                                    onChange={(date) => handleChangeDate(date, "stcDate")}
                                                    disabled={false}
                                                />
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="whCode" className="form-label">รหัสคลัง</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="whCode"
                                                    name="whCode"
                                                    value={searchCriteria.whCode || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="whName" className="form-label">ชื่อคลัง</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="whName"
                                                    name="whName"
                                                    value={searchCriteria.whName || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                        </div>

                                        <div className="row d-flex justify-content-end">
                                            <div className="col-auto mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => handleSearch()}
                                                >
                                                    <i className="fas fa-search" /> ค้นหา
                                                </button>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={handleExportClick}
                                                    disabled={!exportController.hasData || exportController.isExporting}
                                                >
                                                    <i className="fas fa-file-excel" />{" "}
                                                    {exportController.isExporting ? 'กำลังส่งออก...' : 'Export'}
                                                </button>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => initialize()}
                                                >
                                                    <i className="fas fa-undo" /> เริ่มใหม่
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* ReportsTable */}
                            <ReportsTable
                                currentItems={currentItems}
                                currentPage={currentPage}
                                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                dataMasterList={filteredData}
                                itemsPerPage={itemsPerPage}
                                fieldMappings={{
                                    stcDate: 'STC_Date',
                                    itemCode: 'Item_Code',
                                    itemName: 'Item_Name',
                                    docType: 'Doc_Type',
                                    stcQty: 'STC_QTY',
                                    docNo: 'Doc_No',
                                    docNoRef: 'Doc_NoRef',
                                    stcRemark: 'STC_Remark'
                                }}
                                onExportReady={handleExportReady}
                                showExportButton={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default InventoryMovementReport;
